<script>
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Autocomplete from "@shared/svelte/Components/Autocomplete.svelte";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  export let showNewMessageModal;
  export let changeConversationWrapper;

  let selectedRep = null;

  function apiParams() {
    return { search: true, include_integrated_reps: true, exclude_emailless: true };
  }

  function close() {
    selectedRep = null;
    showNewMessageModal = false;
  }

  function NewMessage() {
    if (!selectedRep) {
      return;
    }
    changeConversationWrapper({ sales_reps: selectedRep.ids.map(x => ({ id: x })) });
    close();
  }
</script>

<Modal bind:show={showNewMessageModal}>
  <header class="modal__header padding--small align-left">
    <div class="default-body--bold">
      New Message
      <span class="float-right">
        <Icon type="X" height="14" width="14" extraClassNames="cursor-pointer" onPress={close} />
      </span>
    </div>
  </header>
  <div
    class="background-white manage-participants-modal padding--medium"
    style="width: 90vw; max-width: 600px;"
  >
    <div class="grid-row padding-top--smaller padding-bottom--small">
      <div class="grid-col c12-12">
        <div class="default-body--bold padding-bottom--smallest">To:</div>
        <Autocomplete
          placeholder="Search your sales reps"
          objectType="sales_rep"
          searchUrlInput={`/api/retailer/sales_reps/group_search`}
          apiParams={apiParams()}
          bind:value={selectedRep}
        />
      </div>
    </div>
  </div>
  <footer class="modal__footer align-right padding--small">
    <div class="grid-row">
      <div class="grid-col c6-12 align-right">
        <button
          class="button button--small button--primary button--label padding-right--medium padding-left--medium padding-top--smaller padding-bottom--smaller"
          on:click={NewMessage}
          disabled={selectedRep == null}>Next</button
        >
      </div>
    </div>
  </footer>
</Modal>
